import { useEffect, useRef } from "react";

export interface ContextMenuItem {
  label: string;
  shortcut?: string;
  onClick: () => void;
  disabled?: boolean;
  danger?: boolean;
  divider?: boolean;
}

export default function ContextMenu(props: {
  x: number;
  y: number;
  items: ContextMenuItem[];
  onClose: () => void;
}) {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function onClick(e: MouseEvent) {
      if (ref.current && !ref.current.contains(e.target as Node)) props.onClose();
    }
    function onKey(e: KeyboardEvent) {
      if (e.key === "Escape") props.onClose();
    }
    document.addEventListener("mousedown", onClick);
    document.addEventListener("keydown", onKey);
    return () => {
      document.removeEventListener("mousedown", onClick);
      document.removeEventListener("keydown", onKey);
    };
  }, [props]);

  // Clamp dentro de la ventana
  const w = 220, h = props.items.length * 28 + 8;
  const left = Math.min(props.x, window.innerWidth - w - 4);
  const top = Math.min(props.y, window.innerHeight - h - 4);

  return (
    <div
      ref={ref}
      style={{
        position: "fixed", left, top, width: w, zIndex: 10000,
        background: "var(--bg-elev)", border: "1px solid var(--border)",
        borderRadius: 6, padding: 4,
        boxShadow: "0 10px 24px rgba(0,0,0,0.5)",
        fontSize: 13, userSelect: "none",
      }}
    >
      {props.items.map((it, i) => it.divider ? (
        <div key={`d${i}`} style={{ height: 1, background: "var(--border)", margin: "4px 0" }} />
      ) : (
        <div
          key={i}
          onClick={() => { if (!it.disabled) { it.onClick(); props.onClose(); } }}
          style={{
            padding: "5px 10px", borderRadius: 4, cursor: it.disabled ? "default" : "pointer",
            display: "flex", justifyContent: "space-between", alignItems: "center", gap: 12,
            color: it.disabled ? "var(--text-dim)" : (it.danger ? "var(--danger)" : "var(--text)"),
            opacity: it.disabled ? 0.5 : 1,
          }}
          onMouseEnter={(e) => { if (!it.disabled) e.currentTarget.style.background = "var(--bg-elev-2)"; }}
          onMouseLeave={(e) => { e.currentTarget.style.background = "transparent"; }}
        >
          <span>{it.label}</span>
          {it.shortcut && <span style={{ color: "var(--text-dim)", fontSize: 11 }}>{it.shortcut}</span>}
        </div>
      ))}
    </div>
  );
}
